import { rgba } from 'polished';

export const colors = {
	palette: {
		primary: {
			main: '#008BF6',
			light: '#55B1F9',
			dark: '#005CA4'
		},
		secondary: {
			main: '#FFFFFF',
			light: rgba('#FFFFFF', 0.9),
			dark: '#C7C7C7'
		},
		background: {
			body: '#040404'
		},
		success: '',
		error: '#FF0000',
		warning: '',
		info: '',
		light: '',
		dark: '',
		white: '#FFFFFF',
		black: '#000000',
		divider: '#737373'
	},
	black: '#000',
	white: '#fff',
	semiWhite: '#f8f8f9',
	navyBlue: '#31549b',
	darkNavy: '#17171C',
	darkCharcoal: '#0d0f13',
	charcoalBlue: '#13181C',
	blueLightSemi: '#5f76b5',
	blueLight: '#66afe9',
	blueDark: '#072740',
	blueBlack: '#0a101b',
	blueDarkExtra: '#071325',
	blueOcean: '#66b5d6',
	bluePelorus: '#2a89b5',
	blueAzure: '#4197CA',
	blueAzure075: 'rgba(65, 151, 202, 0.75)',
	blueAzureDark: '#2786BF',
	brown: '#a79d91',
	purpleLight: '#dce3f8',
	turquoiseDark: '#12473f',
	green: '#75aea2',
	grayDarkSemi: '#433e3a',
	blueGray: '#678398',
	grayMain: '#666666',
	grayBorder: '#64686e5e',
	grayLightExtra: '#e5e2e1',
	grayLight: '#ccc',
	graySoft: '#dadada',
	grayReddish: '#95a1af',
	gray: '#79899A',
	graySemiSoft: '#9DA0A4',
	grayMediumWhiteTheme: '#697287',
	grayMediumDarkTheme: '#9D9FA3',
	grayDark: '#2a2d39',
	grayBlack: '#433e3b',
	purpleDark: '#403448',
	orange: '#e26745',
	orangeNormal: '#fb7b0e',
	pinkGray: '#926d8c',
	blackLight: 'rgba(0,0,0,0.74)',
	blackSemiTranslucent: 'rgba(0, 0, 0, 0.5)',
	blackPearl: '#0A101A',
	blackPearl02: 'rgba(10, 16, 26, 0.2)',
	blackGray: '#2d343d',
	whiteSemiTranslucent: 'rgba(255, 255, 255, 0.5)',
	whiteTransparent07: 'rgba(255, 255, 255, 0.7)',
	transparent: 'transparent',
	tvsmart_primary: '#9A6800',
	tvsmart_light: '#FFF369',
	yellow: '#F4B809',
	grayPearl: '#141A23',
	borderGray: '#3C4149',
	borderGrayTranslucent: 'rgb(244, 244, 244, 0.25)',
	silver: '#858585',
	paleBlue: '#4197ca',
	paleGreen: '#2C343D',
	iconGray: '#93969a',
	configurator: {
		background: '#09101a'
	},
	loader: {
		medium: '#2773bc',
		light: '#2da7df'
	},
	alert: {
		border: '#ebccd1',
		bg: '#f2dede'
	},
	footer: {
		height: 6,
		link: '#697287'
	},
	channels: {
		progressbar_width: 20.2
	},
	program_details: {
		row: '#f4f4f6'
	},
	progressbar: {
		grayLight: '#e5e6ea',
		default: '#b1b1b1'
	},
	vod: {
		black: 'rgb(12,18,25)',
		blue: 'rgb(45, 104, 144)',
		btnGlow: {
			blueLight: 'rgb(20, 159, 197)',
			blue: 'rgb(39, 66, 136)'
		},
		font: {
			white: 'rgb(255,255,255)',
			whiteGray: '#ebebeb',
			whiteGrayDark: '#afafaf',
			whiteGrayLight: '#e6e3df'
		}
	},
	player: {
		grayLight: '#aeaeae'
	},
	calendarSelectedDay: '#1890ff',
	promotionPrice: '#F2C919',
	productDetails: {
		noCover: '#2a3155'
	},
	placeholder: '#202027',
	tvsmart: {
		loader: {
			basic: '#9A6800',
			medium: '#EAB036',
			light: '#FFF369'
		},
		epg_progressbar: '#EAB036',
		button: {
			gradient: 'linear-gradient(0deg, #31549B 0%, #2786BF 53.8%)',
			radius: '4px'
		}
	},
	firebase_auth: {
		facebook: '#4267b2',
		phone: '#07bc7e',
		google: { grayBcg: '#eee' }
	},
	invoice: {
		input: 'rgba(10,16,26,0.2)'
	},
	watchingGEOLock: {
		color: '#88898A'
	},
	operators: {
		card: {
			borderColor: '#2c343d'
		}
	},
	login_scroll_thumb: 'rgba(255, 255, 255, 0.3)',
	login_scroll_track: 'rgba(255, 255, 255, 0.1)',
	recordings: {
		deviceTileBg: '#11161E'
	},
	channelSlideThumb: 'rgba(255,255,255, 0.12)'
};
